import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IconModule} from '../icon';
import {MoreButtonComponent} from './more-button/more-button.component';
import {InfoButtonComponent} from './info-button/info-button.component';
import {ShadowedButtonComponent} from './shadowed-button/shadowed-button.component';
import {ButtonComponent} from './button/button.component';
import {ConfirmButtonPairComponent} from './confirm-button-pair/confirm-button-pair.component';

@NgModule({
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    MoreButtonComponent,
    InfoButtonComponent,
    ShadowedButtonComponent,
    ButtonComponent,
    ConfirmButtonPairComponent
  ],
  declarations: [
    MoreButtonComponent,
    InfoButtonComponent,
    ShadowedButtonComponent,
    ButtonComponent,
    ConfirmButtonPairComponent
  ]
})
export class ButtonModule {
}
